module.exports = __webpack_public_path__ + "img/warp_beast.24e4725b.png";